import SharedController from 'controller/SharedController';

// Login views
import Login from 'views/pages/users/login/Login';

// General user views
import UserHome from 'views/pages/users/home/Home';

// Show (content) views
import GroupShow from 'views/pages/groups/show/Show';
import ChapterShow from 'views/pages/chapters/show/Show.svelte';
import SectionShow from 'views/pages/sections/show/Show';
import ActivityShow from 'views/pages/activities/show/Show';

import ChapterShare from 'views/pages/chapters/share/Share.svelte';
import SectionShare from 'views/pages/sections/share/Share.svelte';
import ActivityShare from 'views/pages/activities/share/Share.svelte';

export default class Controller extends SharedController {

    constructor() {

        super();

        // Create a holder for the active path
        this.activePath = [];
        this.activeParams = []

        this.urlMap = {
            users: {
                login: Login,
                home: UserHome,
                settings: () => {
                    return import(
                        /* rspackChunkName: "settings-users" */
                        'views/pages/users/settings/Settings'
                    );
                },
                feedback: () => {
                    return import(
                        /* rspackChunkName: "users-feedback" */
                        'views/pages/users/feedback/FeedbackOverview.svelte'
                    )
                },
                join: () => {
                    return import(
                        /* rspackChunkName: "signup-register" */
                        'views/components/register/steps/student/addJoinCode/addJoinCode'
                    )
                },
                register_join_code: () => {
                    return import(
                        /* rspackChunkName: "signup-register" */
                        'views/components/register/steps/student/addJoinCode/addJoinCode'
                    )
                },
                register_validation_mail_sent: () => {
                    return import(
                        /* rspackChunkName: "signup-register" */
                        'views/components/register/steps/generic/validationMailSent/ValidationMailSent'
                    )
                },
                welcome: () => {
                    return import(
                        /* rspackChunkName: "signup-register" */
                        'views/components/register/steps/generic/welcome/Welcome'
                    )
                },
                welcome_teacher: () => {
                    return import(
                        /* rspackChunkName: "signup-register" */
                        'views/components/register/steps/generic/welcome/cards/newTeacher/WelcomeTeacher'
                    )
                },
                register_name: () => {
                    return import(
                        /* rspackChunkName: "signup-register" */
                        'views/components/register/steps/generic/registerName/RegisterName'
                    )
                },
                reset_password: () => {
                    return import(
                        /* rspackChunkName: "signup-register" */
                        'views/components/register/steps/generic/resetPassword/ResetPassword'
                    )
                }
            },
            groups: {
                author: () => {
                    return import(
                        /* rspackChunkName: "author-groups" */
                        'views/pages/groups/author/Author'
                    );
                },
                show: GroupShow,
                invite: () => {
                    return import(
                        /* rspackChunkName: "settings-invite-students" */
                        'views/pages/groups/inviteStudents/InviteStudents'
                    );
                },
                settings: () => {
                    return import(
                        /* rspackChunkName: "settings-groups" */
                        'views/pages/groups/settings/Settings'
                    );
                },
                admin: () => {
                    return import(
                        /* rspackChunkName: "admin" */
                        'views/pages/groups/admin/GroupsAdmin.svelte'
                    )
                },
                admin_create: () => {
                    return import(
                        /* rspackChunkName: "admin-create-group" */
                        'views/pages/groups/admin/CreateGroups.svelte'
                    )
                },
                progress: () => {
                    return import(
                        /* rspackChunkName: "progress-groups" */
                        'views/pages/groups/progress/Progress'
                    )
                },
                results: () => {
                    return import(
                        /* rspackChunkName: "results-groups" */
                        'views/pages/groups/results/Results'
                    )
                },
                annotate: () => {
                    return import(
                        /* rspackChunkName: "annotate" */
                        'views/pages/groups/annotate/Annotate'
                    )
                },
                pick_course: () => {
                    return import(
                        /* rspackChunkName: "signup-pick-course" */
                        'views/pages/groups/pickCourse/PickCourse.svelte'
                    )
                },
                create: () => {
                    return import(
                        /* rspackChunkName: "signup-create-group" */
                        'views/pages/groups/create/Create'
                    )
                },
                created: () => {
                    return import(
                        /* rspackChunkName: "signup-create-group" */
                        'views/pages/groups/created/Created'
                    )
                },
                planner: () => {
                    return import(
                        /* rspackChunkName: "planner-groups" */
                        'views/pages/groups/planner/Planner'
                    )
                },
                createaccounts: () => {
                    return import(
                        /* rspackChunkName: "signup-no-email" */
                        'views/pages/groups/createStudents/CreateStudents'
                    )
                },
                search: () => {
                    return import(
                        /* rspackChunkName: "search-material" */
                        'views/pages/groups/search/Search'
                    )
                },
                focus: () => {
                    return import(
                        /* rspackChunkName: "group-focus" */
                        'views/pages/groups/focus/Focus.svelte'
                    )
                },
                teacher_materials: () => {
                    return import(
                        /* rspackChunkName: "groups-teacher-materials" */
                        'views/pages/groups/teacherMaterials/TeacherMaterials.svelte'
                    )
                }
            },
            chapters: {
                author: () => {
                    return import(
                        /* rspackChunkName: "author-chapters" */
                        'views/pages/chapters/author/Author'
                    );
                },
                show: ChapterShow,
                progress: () => {
                    return import(
                        /* rspackChunkName: "progress-groups" */
                        'views/pages/groups/progress/Progress'
                    )
                },
                annotate: () => {
                    return import(
                        /* rspackChunkName: "annotate" */
                        'views/pages/chapters/annotate/Annotate'
                    )
                },
                share: ChapterShare
            },
            sections: {
                author: () => {
                    return import(
                        /* rspackChunkName: "author-sections" */
                        'views/pages/sections/author/Author'
                    );
                },
                show: SectionShow,
                progress: () => {
                    return import(
                        /* rspackChunkName: "progress-groups" */
                        'views/pages/groups/progress/Progress'
                    )
                },
                annotate: () => {
                    return import(
                        /* rspackChunkName: "annotate" */
                        'views/pages/sections/annotate/Annotate'
                    )
                },
                share: SectionShare
            },
            activities: {
                author: () => {
                    return import(
                        /* rspackChunkName: "author-activities" */
                        'views/pages/activities/author/Author'
                    );
                },
                show: ActivityShow,
                progress: () => {
                    return import(
                        /* rspackChunkName: "progress-activities" */
                        'views/pages/activities/progress/Progress'
                    )
                },
                annotate: () => {
                    return import(
                        /* rspackChunkName: "annotate" */
                        'views/pages/activities/annotate/Annotate'
                    )
                },
                grading: () => {
                    return import(
                        /* rspackChunkName: "grading-activities" */
                        'views/pages/activities/studentGrading/StudentGrading'
                    )
                },
                share: ActivityShare
            },
            task_groups: {
                author: () => {
                    return import(
                        /* rspackChunkName: "author-task-groups" */
                        'views/pages/task_groups/author/Author'
                    );
                },
                show: ActivityShow,
                progress: () => {
                    return import(
                        /* rspackChunkName: "progress-task-groups" */
                        'views/pages/task_groups/progress/ShowAllAnswers'
                    )
                },
            },
            library: {
                home: () => {
                    return import(
                        /* rspackChunkName: "library-home" */
                        'views/pages/library/home/Home'
                    );
                },
                view: () => {
                    return import(
                        /* rspackChunkName: "library-view" */
                        'views/pages/library/view/View'
                    );
                },
                add: () => {
                    return import(
                        /* rspackChunkName: "library-add" */
                        'views/pages/library/add/Add'
                    );
                },
                author: () => {
                    return import(
                        /* rspackChunkName: "author-task-groups-library" */
                        'views/pages/library/author/Author'
                    );
                },
                teacher_materials: () => {
                    return import(
                        /* rspackChunkName: "groups-teacher-materials" */
                        'views/pages/groups/teacherMaterials/TeacherMaterials.svelte'
                    )
                }
            },

            portfolio: {
                students: () => {
                    return import(
                        /* rspackChunkName: "portfolio-projects" */
                        'views/pages/portfolio/Students'
                    );
                },
                group: () => {
                    return import(
                        /* rspackChunkName: "portfolio-group" */
                        'views/pages/portfolio/group/Group'
                    )
                },
                project: () => {
                    return import(
                        /* rspackChunkName: "portfolio-project" */
                        'views/pages/portfolio/project/Project'
                    );
                },
                projects: () => {
                    return import(
                        /* rspackChunkName: "portfolio-projects" */
                        'views/pages/portfolio/projects/Projects'
                    );
                },
            },

            students: {
                progress: () => {
                    return import(
                        /* rspackChunkName: "progress-students" */
                        'views/pages/students/progress/StudentsProgress'
                    )
                },
                results: () => {
                    return import(
                        /* rspackChunkName: "results-groups" */
                        'views/pages/students/results/Results'
                    )
                },
                admin: () => {
                    return import(
                        /* rspackChunkName: "admin" */
                        'views/pages/users/admin/UsersAdmin.svelte'
                    )
                }
            },

            teachers: {
                admin: () => {
                    return import(
                        /* rspackChunkName: "admin" */
                        'views/pages/users/admin/UsersAdmin.svelte'
                    )
                },
            },

            answers: {
                progress: () => {
                    return import(
                        /* rspackChunkName: "progress-answers" */
                        'views/pages/answers/progress/AnswerBrowser'
                    )
                }
            },

            products: {
                payment_status: () => {
                    return import(
                        /* rspackChunkName: "signup-register" */
                        'views/pages/products/payments/PaymentStatus'
                    )
                },
                anonymous_payment_status: () => {
                    return import(
                        /* rspackChunkName: "signup-register" */
                        'views/pages/products/payments/PaymentStatus'
                    )
                }
            },

            licenses: {
                renewal: () => {
                    return import(
                        /* rspackChunkName: "license-renewal" */
                        'views/pages/licenses/LicenseRenewal'
                    )
                }
            },

            words: {
                home: () => {
                    return import(
                        /* rspackChunkName: "words" */
                        'views/pages/words/home/Home.svelte'
                    )
                },
                list: () => {
                    return import(
                        /* rspackChunkName: "words" */
                        'views/pages/words/List'
                    )
                },
                course: () => {
                    return import(
                        /* rspackChunkName: "words" */
                        'views/pages/words/course/Course.svelte'
                    )
                },
                sessions: () => {
                    return import(
                        /* rspackChunkName: "words" */
                        'views/pages/words/Session'
                    )
                },
                results: () => {
                    return import(
                        /* rspackChunkName: "words" */
                        'views/pages/words/results/Results'
                    )
                },
            },

            accessor: {
                login: () => {
                    return import(
                        /* rspackChunkName: "accessor" */
                        'views/pages/accessor/login/Login'
                    )
                },
                connections: () => {
                    return import(
                        /* rspackChunkName: "accessor" */
                        'views/pages/accessor/connections/Connections'
                    )
                }
            },

        };

        // List of views that are strictly accessible without a userID
        this.allowedWithoutUserID = {
            users: [
                'login',
                'register_join_code',
                'welcome',
                'welcome_teacher',
                'register_name',
                'register_validation_mail_sent',
                'reset_password'
            ],
            products: [
                'anonymous_payment_status'
            ],
            accessor: [
                'login'
            ]
        };

    }

}
